import React from 'react'
import classNames from 'classnames'
import { Text } from '@jisr-hr/design-system'
import { Trans } from 'react-i18next'
import I18n from 'translations/i18n'
import { isRtl } from 'utils/uiHelpers'
import { labels } from 'utils/whitelabel'

const lang = isRtl ? 'ar' : 'en'

const LoginContent = () => {
  const isMaken = labels.name === 'Maken'
  const isAhad = labels.name === 'Ahad'
  const isJisr = labels.name === 'Jisr'

  return (
    <div
      className={classNames(
        'login--content-box',
        isMaken && 'login--content-maken',
        isAhad && 'login--content-ahad',
      )}
    >
      <div className="login-info">
        {!isMaken && (
          <img
            src={labels.logo}
            alt={labels.translation_app_name}
          />
        )}
        <Text typography="headline">
          {I18n.t('payroll')}.<br />
          {I18n.t('attendance')}.<br />
          {I18n.t('hr_management')}.<br />
          {I18n.t('reports_and_more')}.<br />
        </Text>
        <Text
          typography="paragraph14"
          color="var(--black)"
        >
          <Trans
            i18nKey="automate_your_hr_operations_and_focus_on_your_business"
            components={{ b: <br /> }}
          />
        </Text>
        {isJisr && (
          <Text
            as="a"
            typography="paragraph14"
            href={`https://jisr.net/${lang}/blog`}
            target="_blank"
            rel="noopener noreferrer"
            color="var(--color-brand-primary-default-new)"
          >
            {I18n.t('visit_our_knowledgebase')}.<br />
          </Text>
        )}
      </div>
    </div>
  )
}

export default LoginContent
